import * as tslib_1 from "tslib";
import * as React from 'react';
import getFriendlySubject from 'owa-mail-compose-store/lib/utils/getFriendlySubject';
import strings from 'owa-strings/owa-mail-strings';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { lazyCloseTab } from 'owa-tab-store';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
var styles = require('./ComposeTab.scss');
var classNames = require('classnames');
var ComposeTab = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeTab, _super);
    function ComposeTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickCloseButton = function (e) {
            e.stopPropagation();
            lazyCloseTab.importAndExecute(_this.props.viewState);
        };
        return _this;
    }
    ComposeTab.prototype.render = function () {
        var _a = this.props, viewState = _a.viewState, className = _a.className, subjectClassName = _a.subjectClassName;
        var composeViewState = viewState.data;
        var subject = getFriendlySubject(composeViewState.subject);
        switch (composeViewState.asyncSendState) {
            case 3 /* Timeout */:
                return (React.createElement("div", { className: className, title: subject },
                    React.createElement(Spinner, { className: styles.leftIcon }),
                    React.createElement("div", { className: subjectClassName }, strings.messageIsSendingTitle)));
            case 2 /* Error */:
                return (React.createElement("div", { className: className, title: subject },
                    React.createElement(Icon, { iconName: "Error" /* Error */, className: classNames(styles.leftIcon, styles.error) }),
                    React.createElement("div", { className: subjectClassName }, strings.messageSendingFailTitle)));
            case 4 /* Sent */:
                return (React.createElement("div", { className: className, title: subject },
                    React.createElement(Icon, { iconName: "CheckMark" /* CheckMark */, className: classNames(styles.leftIcon, styles.checkmark) }),
                    React.createElement("div", { className: subjectClassName }, strings.messageIsSentTitle)));
            default:
                return (React.createElement("div", { className: className, title: subject },
                    React.createElement(Icon, { iconName: "Edit" /* Edit */, className: styles.leftIcon }),
                    React.createElement("div", { className: subjectClassName }, subject),
                    React.createElement(IconButton, { iconProps: { iconName: "Cancel" /* Cancel */ }, onClick: this.onClickCloseButton, className: styles.rightIcon })));
        }
    };
    ComposeTab = tslib_1.__decorate([
        observer
    ], ComposeTab);
    return ComposeTab;
}(React.Component));
export default ComposeTab;
//# sourceMappingURL=ComposeTab.js.map